import React from 'react';
import {FC} from "react"
import styled from 'styled-components';
import {Link as RouterLink, LinkProps as RouterLinkProps} from "react-router-dom"
import {
  color, flexbox, typography, space, layout, grid, border, position, background, borders, boxShadow, BackgroundProps, BordersProps, BoxShadowProps
} from "styled-system"
import warningIcon from "./icons/warning.svg"
import checkIcon from "./icons/check.svg"
import css from "@styled-system/css"

import {
  ColorProps,
  OpacityProps,
  FlexboxProps,
  TypographyProps,
  SpaceProps,
  LayoutProps,
  GridProps,
  BorderProps,
  PositionProps,
} from "styled-system"

// Navigation:
type NavigationProps = {
  n: number,
  maxIndex: number
}

const NavigationRoot = styled.div<SpaceProps & NavigationProps>`
  display: flex;
  justify-content: space-between;
  width: 100%;
  ${space}
`


export const Navigation: FC<NavigationProps & SpaceProps> = (props) => {
  const n = props.n
  const maxIndex = props.maxIndex

    let r: any = []
    for (let i = 1; i <= maxIndex; i++) {
        if (i < n) {
            r.push(
                <Circle backgroundColor="primary" height={50} width={50} key={i} zIndex={2}>
                    <img src={checkIcon} alt="check" />
                </Circle>
            )
        } else if (i === n) {
            r.push(
                <Circle backgroundColor="primary" height={50} width={50} key={i} zIndex={2}>
                    <Text fontSize="xlarge" color="white">{i}</Text>
                </Circle>
            )
        } else {
            r.push(
                <Circle backgroundColor="gray" height={50} width={50} key={i} zIndex={2}>
                    <Text fontSize="xlarge">{i}</Text>
                </Circle>
            )
        }
    }

  return (
    <div style={{position: "relative"}}>
      <NavigationRoot {...props}>{r}</NavigationRoot>
      <div style={{ position: "absolute", width: "100%", border: "1px solid #D0DBE1", top: "25px", zIndex: 1}} />
    </div>
  )
}

export const Textarea = styled.textarea<SpaceProps & ColorProps & LayoutProps & CustomProps>`
  border: 1px solid;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: ${(props: any) => (props.invalid ? "#F8E4E4" : "white")};
  border-color: ${(props: any) => (props.invalid ? "#EB5757" : "#DDDDDD")};

  ${space}
  ${color}
  ${layout}
`

export const WarningBox: FC<LayoutProps & SpaceProps> = (props) => {
  return (
    <Warning {...props}>
    <div style={{display: "flex", width: "100%"}}>
      <img src={warningIcon} alt="check" />
      {props.children}
    </div>
    </Warning>
  )
}

type ButtonProps = ColorProps & OpacityProps & LayoutProps & BorderProps & SpaceProps
export const ButtonRoot = styled.button<ButtonProps>`
  border-radius: 5px;
  font-family: Hiragino Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  // line-height: 32px;
  padding-top: 10px;
  padding-bottom: 10px;

  text-align: center;
  text-decoration: none;
  display: inline-block;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  appearance: none;
  vertical-align: middle;
  border: none;

  ${color}
  ${layout}
  ${border}
  ${space}
`

export const Button: FC<any> = (props) => {
  // TODO: More strict typing on props
  if (props.disabled) {
    return (<ButtonRoot {...props} disabled={true} opacity={0.3}>{props.children}</ButtonRoot>)
  }
  return (<ButtonRoot {...props}>{props.children}</ButtonRoot>)
}

export const LinkButton = styled(RouterLink)<RouterLinkProps & ButtonProps & SpaceProps>`
  border-radius: 5px;
  font-family: Hiragino Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  // line-height: 32px;
  padding-top: 10px;
  padding-bottom: 10px;

  text-align: center;
  text-decoration: none;
  display: inline-block;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
  appearance: none;
  vertical-align: middle;
  ${color}
  ${layout}
  ${space}
  ${border}
`

export const ViewRoot = styled.div<LayoutProps>`
  ${layout};
  position: relative;
  min-height: 100vh;
  background: #F2F7F8;
  // display: grid;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 20px 20px 20px;
  row-gap: 16px;
`

export const GridView = styled.div<GridProps>`
  display: grid;
  row-gap: 16px;
  top: 0;
  width: 100%;
  ${grid}
`

export const View: FC<LayoutProps & SpaceProps & FlexboxProps> = (props) => {
  return (
    <ViewRoot>
      <GridView {...props}>
        {props.children}
      </GridView>
    </ViewRoot>
  )

}

export const DivRoot = styled.div`
  box-sizing: border-box;
  ${typography};
  ${space};
  ${layout};
  ${color};
  ${position};
  ${flexbox};
  ${grid};
  ${background};
  ${borders};
  ${boxShadow};
`

export type DivProps = TypographyProps &
  SpaceProps &
  LayoutProps &
  ColorProps &
  PositionProps &
  FlexboxProps &
  GridProps &
  BackgroundProps &
  BordersProps &
  BoxShadowProps &
  React.HTMLAttributes<HTMLDivElement>

export const Div: FC<DivProps> = props => {
  return (
    <DivRoot {...props} >
      {props.children}
    </DivRoot>
  )
}
export const SpanRoot = styled.span`
  box-sizing: border-box;
  ${typography};
  ${space};
  ${layout};
  ${color};
  ${position};
  ${flexbox};
  ${grid};
  ${background};
  ${borders};
  ${boxShadow};
`

export type SpanProps = TypographyProps &
  SpaceProps &
  LayoutProps &
  ColorProps &
  PositionProps &
  FlexboxProps &
  GridProps &
  BackgroundProps &
  BordersProps &
  BoxShadowProps &
  React.HTMLAttributes<HTMLSpanElement>

export const Span: FC<SpanProps> = props => {
  return (
    <SpanRoot {...props} >
      {props.children}
    </SpanRoot>
  )
}

export const Flexbox = styled.div<FlexboxProps & LayoutProps & SpaceProps & ColorProps>`
  ${flexbox}
  ${layout}
  ${space}
  ${color}
  display: flex;
`

export const Header = styled.div`

`

export const Text = styled.p<TypographyProps & LayoutProps & ColorProps & SpaceProps>`
  color: #333333;
  margin: 0px;
  line-height: 21px;
  ${typography}
  ${layout}
  ${space}
  ${color}
  font-family: Hiragino Sans;
`

export const Text2 = styled.div<TypographyProps & LayoutProps & ColorProps & SpaceProps>`
  ${typography}
  ${layout}
  ${space}
  color: #333333;
  ${color}
  font-family: Hiragino Sans;
`

export const InlineText = styled.span<TypographyProps & LayoutProps>`
  ${typography}
  ${layout}
  display: inline-block;
`

export const Box = styled.div<ColorProps & SpaceProps & GridProps & BorderProps & PositionProps>`
  padding: 20px 24px 20px 24px;
  width: 100%;

  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  box-sizing: border-box;
  border-radius: 5px;
  display: grid;
  row-gap: 16px;
  ${space}
  ${color}
  ${grid}
  ${border}
  ${position}
`

// Box component containing radiobox or checkbox
export const SelectionBox = styled.div<ColorProps & SpaceProps>`
  ${space}

  padding: 16px 16px 16px 16px;
  width: 100%;

  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  flex-direction: row;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
  align-items: center;
`

export const Footer = styled.span<SpaceProps>`
  font-family: Helvetica;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 18px;
  text-align: center;

  margin-top: 20px;
  margin-bottom: 20px;

  color: #8E8E8E;

  ${space}
`

export const CFooter: FC = () => {
  return <Footer>&copy; MICIN, Inc.</Footer>
}

export const PlaceHolder = styled.div<SpaceProps & LayoutProps & ColorProps>`
  ${space}
  ${layout}
  ${color}

  padding: 16px 16px 16px 16px;
  border: 1px solid #DDDDDD;
  box-sizing: border-box;
  border-radius: 5px;
`

export const Circle = styled.div<ColorProps & LayoutProps & PositionProps>`
  display: flex;
  flex-flow: row;
  justify-content: center;
  ${color}
  ${layout}
  border-radius: 50%;
  align-items: center;
  ${position}
`

export const Warning = styled.div<LayoutProps & SpaceProps>`
  ${layout}
  ${space}

  background: #F8E4E4;
  border: 1px solid #EB5757;
  box-sizing: border-box;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  padding: 16px 16px 16px 16px;
`
interface CustomProps {
  invalid?: boolean
}
export const Input = styled('input')<TypographyProps & SpaceProps & LayoutProps & ColorProps & BorderProps & CustomProps>`
  background-color: ${(props: any) => (props.invalid ? "#F8E4E4" : "white")};
  font-family: inherit;
  color: #273528;
  padding-left: 5px;
  padding-right: 5px;
  line-height: 32px;
  border: 1px solid;
  border-radius: 5px;
  box-sizing: border-box;
  border-color: ${(props: any) => (props.invalid ? "#EB5757" : "#DDDDDD")};
  font-size: 14px;
  ${typography}
  ${layout}
  ${color}
  ${border}
`

export const InputError = styled('div')(
  css({
    color: 'font.error',
    fontSize: 'small',
    mb: "2px"
  }),
)


export const Label = styled.label<TypographyProps & SpaceProps & ColorProps & LayoutProps>`
  ${color}
  ${space}
  ${typography}
  ${layout}
  display: inline-block;
`

export const FormRoot = styled.form<LayoutProps & ColorProps>`
  ${layout}
`

export const Form: FC<React.FormHTMLAttributes<HTMLFormElement>> = (props) => {
  return (
    <FormRoot {...props}>
      <GridView>
        {props.children}
      </GridView>
    </FormRoot>
  )
}

// Separator
export const Separator = styled.div`
  height: 0px;
  border: 1px solid #DDDDDD;
`
